(function() {
    'use strict'

    // Usage:
    //
    // Creates:
    //

    angular
        .module('wf.common')
        .component('wfCheck', {
            templateUrl: 'scripts/wf/common/wfCheck.component.html',
            controller: wfCheckController,
            controllerAs: 'vm',
            bindings: {
                value: '=?',
                label: '<',
                onChange: '&',
                customClass: '<',
                valueObject: '=?',
                valuePropertyName: '=?',
            },
        })

    wfCheckController.$inject = ['$element', '$translate']
    function wfCheckController($element, $translate) {
        const vm = this

        vm.onChangeInternal = function() {
            if (vm.valueObject && vm.valuePropertyName) {
                vm.valueObject[vm.valuePropertyName] = !vm.valueObject[vm.valuePropertyName]
            }
            if (vm.onChange) {
                vm.onChange()
            }
        }

        if (vm.valueObject && vm.valuePropertyName) {
            if (vm.valueObject[vm.valuePropertyName] === undefined) {
                vm.valueObject[vm.valuePropertyName] = false
            }

            vm.value = vm.valueObject[vm.valuePropertyName]
        }

        $element.css('visibility', 'hidden')

        _.assign(vm, {
            id: _.uniqueId(),
        })

        ////////////////

        vm.$onInit = function() {
            setTimeout(() => {
                $element.css('visibility', '')
            })

            if (vm.allowUndefinedValue) {
                $element.find('div.icheckbox_wf').click(() => {

                })
            }
        }
        vm.$onChanges = function(changesObj) { }
        vm.$onDestroy = function() { }
    }
})()
